(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["conversion-product-tools"] && !Shopify.designMode) return;
  try {
    (() => {
  const bar = document.querySelector('[data-conversion-sticky-atc]');
  const stickyButton = document.querySelector('[data-conversion-sticky-button]');
  const mainButton = document.querySelector('.product-form__submit');
  if (!bar || !stickyButton || !mainButton) return;

  const sync = () => {
    stickyButton.disabled = mainButton.disabled;
    const label = mainButton.querySelector('span');
    if (label && label.textContent.trim()) stickyButton.textContent = label.textContent.trim();
  };

  sync();

  const visibilityObserver = new IntersectionObserver(
    (entries) => {
      const shouldShow = !entries[0].isIntersecting && !mainButton.disabled;
      bar.classList.toggle('is-visible', shouldShow);
    },
    { threshold: 0.15 }
  );
  visibilityObserver.observe(mainButton);

  const buttonObserver = new MutationObserver(sync);
  buttonObserver.observe(mainButton, { attributes: true, childList: true, subtree: true });

  stickyButton.addEventListener('click', () => {
    if (!mainButton.disabled) mainButton.click();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
